import { CustomAlertDialog } from '@pco/molecules/CustomAlertDialog';
import { useDealerSearchStore } from '@pco/stores/dealerSearch.store';

export interface DealerRedirectProps {
	title: string;
	subtitle: string;
	continueCTA: {
		text: string;
	};
	cancelCTA: {
		text: string;
	};
}
export const DealerRedirect = ({
	title,
	subtitle,
	continueCTA,
	cancelCTA,
}: DealerRedirectProps) => {
	const { selectedDealerInfo, setSelectedDealerInfo } = useDealerSearchStore();

	const bindings = {
		dealerName: selectedDealerInfo?.dealerName,
	};
	const unSetSelectedDealerInfo = () => setSelectedDealerInfo(null);

	return (
		<CustomAlertDialog
			open={Boolean(selectedDealerInfo?.autopartsWebsiteURL)}
			onOpenChange={(isOpen) => {
				if (!isOpen) {
					unSetSelectedDealerInfo();
				}
			}}
			title={title}
			subtitle={subtitle}
			bindings={bindings}
			primaryCTA={{
				label: continueCTA?.text,
				onClick: () => {
					if (selectedDealerInfo?.autopartsWebsiteURL) {
						window.location.href = selectedDealerInfo.autopartsWebsiteURL;
					}
				},
			}}
			secondaryCTA={{
				label: cancelCTA?.text,
				onClick: unSetSelectedDealerInfo,
			}}
		/>
	);
};


export default DealerRedirect;
